import React from "react";
import styled from "styled-components";
import { colors } from "../../../../theme";
import { POINTER_HOVER_MEDIA } from "../../../styles/pointer-hover";

const Wrapper = styled.div`
  padding-top: 0.5rem;

  @media (min-width: 1024px) {
    padding-top: 0;
  }
`;

const CertificationList = styled.div`
  word-break: break-word;
`;

const CertificationItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.5rem;
  }
`;

const Period = styled.div`
  font-size: 0.75rem;
  line-height: 1.35;
  color: #374151;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const titleStyles = `
  font-size: 0.875rem;
  line-height: 1.35;
  font-weight: 700;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const Title = styled.h4`
  ${titleStyles}
  color: #111827;
`;

const TitleLink = styled.a`
  ${titleStyles}
  display: inline-block;
  color: ${colors.linkHover.light};
  text-decoration: none;
  transition: color 0.2s ease;

  @media ${POINTER_HOVER_MEDIA} {
    &:hover {
      color: ${colors.linkHover.dark};
      text-decoration: underline;
    }
  }

  &:focus-visible {
    outline: 2px solid
      color-mix(in srgb, ${colors.linkHover.dark} 50%, transparent);
    outline-offset: 2px;
  }
`;

const Issuer = styled.p`
  margin: 8px 0 0;
  font-size: 0.8125rem;
  line-height: 1.35;
  color: #374151;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const CERTIFICATIONS = [
  {
    title: "Claude code in action",
    issuer: "Anthropic",
    period: "June 2026 - Present",
    href: "https://verify.skilljar.com/c/g7q4og53h4pw",
  },
  {
    title: "Introduction to model context protocol",
    issuer: "Anthropic",
    period: "June 2026 - Present",
    href: "https://verify.skilljar.com/c/6x5k3s7rwt3r",
  },
  {
    title: "Introduction to agent skills",
    issuer: "Anthropic",
    period: "June 2026 - Present",
    href: "https://verify.skilljar.com/c/zs4fshg8m7qf",
  },
  {
    title: "Turing certified remote developer",
    issuer: "Turing",
    period: "March 2022 - Present",
    href: "https://matching.turing.com/developer-resume-preview/e905969c1e9d992993e884d1c1d42814905e1879b608e6",
  },
  {
    title: "Toptal certified remote developer",
    issuer: "Toptal",
    period: "March 2022 - Present",
    href: "https://www.toptal.com/developers/resume/parmeet-singh",
  },
  {
    title: "Modern application development",
    issuer: "NPTEL",
    period: "March 2019 - Present",
  },
  {
    title: "Learn to code with JavaScript",
    issuer: "Open Classrooms",
    period: "November 2018 - Present",
    href: "https://drive.google.com/file/d/14SXzZnWrvmU21CIohjhvB_igtUue0Pqe/view",
  },
  {
    title: "Build web apps with ReactJS",
    issuer: "Open Classrooms",
    period: "November 2018 - Present",
    href: "https://drive.google.com/file/d/1WgdZc8XZ-nYQD4_46jMoTZzzb2EANZN9/view?usp=drive_open",
  },
  {
    title: "Google India challenge scholarship",
    issuer: "Udacity",
    period: "February 2018 - Present",
  },
];

export default function CertificationsSection() {
  return (
    <Wrapper>
      <CertificationList>
        {CERTIFICATIONS.map(({ title, issuer, period, href }) => (
          <CertificationItem key={title}>
            <Period>{period}</Period>
            <div>
              {href ? (
                <TitleLink
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  {title}
                </TitleLink>
              ) : (
                <Title>{title}</Title>
              )}
              <Issuer>{issuer}</Issuer>
            </div>
          </CertificationItem>
        ))}
      </CertificationList>
    </Wrapper>
  );
}
